import React from 'react';
import type { CoinData } from '../types/interfaces';
import { formatCurrency } from '../utils/currency';

interface MarketStatsProps {
  data: CoinData[];
  currency?: string;
}

export default function MarketStats({ data, currency = 'usd' }: MarketStatsProps) {
  const totalMarketCap = data.reduce((sum, coin) => sum + (coin.market_cap || 0), 0);
  const totalVolume = data.reduce((sum, coin) => sum + (coin.total_volume || 0), 0);
  const btc = data.find(coin => coin.id === 'bitcoin');
  const btcDominance = btc && btc.market_cap && totalMarketCap > 0
    ? `${((btc.market_cap / totalMarketCap) * 100).toFixed(2)}%`
    : '-';

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <div className="group bg-gradient-to-br from-bg-secondary to-bg-tertiary p-7 rounded-3xl text-center shadow-bubble border-2 border-primary/10 hover:border-primary/30 transition-all duration-300 hover:scale-105 hover:shadow-bubble-lg">
        <div className="text-3xl mb-3">💎</div>
        <span className="block text-text-secondary text-sm font-semibold mb-3 uppercase tracking-wider">Total Market Cap</span>
        <span className="block text-3xl font-bold bg-gradient-to-r from-text to-primary bg-clip-text text-transparent">{formatCurrency(totalMarketCap, currency, { compact: true })}</span>
      </div>
      <div className="group bg-gradient-to-br from-bg-secondary to-bg-tertiary p-7 rounded-3xl text-center shadow-bubble border-2 border-primary/10 hover:border-primary/30 transition-all duration-300 hover:scale-105 hover:shadow-bubble-lg">
        <div className="text-3xl mb-3">📊</div>
        <span className="block text-text-secondary text-sm font-semibold mb-3 uppercase tracking-wider">24h Volume</span>
        <span className="block text-3xl font-bold bg-gradient-to-r from-text to-primary bg-clip-text text-transparent">{formatCurrency(totalVolume, currency, { compact: true })}</span>
      </div>
      <div className="group bg-gradient-to-br from-bg-secondary to-bg-tertiary p-7 rounded-3xl text-center shadow-bubble border-2 border-primary/10 hover:border-primary/30 transition-all duration-300 hover:scale-105 hover:shadow-bubble-lg">
        <div className="flex items-center justify-center gap-2 mb-3">
          <div className="text-3xl">₿</div>
          <a
            href="https://thatsbtcnotbitcoin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-yellow-400 hover:text-yellow-300 text-2xl transition-all duration-300 hover:scale-110 active:scale-95"
            title="That's BTC, not Bitcoin"
          >
            ⚠️
          </a>
        </div>
        <span className="block text-text-secondary text-sm font-semibold mb-3 uppercase tracking-wider">BTC Dominance</span>
        <span className="block text-3xl font-bold bg-gradient-to-r from-text to-primary bg-clip-text text-transparent">{btcDominance}</span>
      </div>
    </div>
  );
}

